<template>
  <div
    class="cfg-kpi-card"
    :class="{ 'cfg-kpi-card--sel': highlight }"
    :style="{ '--kpi-accent': accentColor }"
  >
    <div class="cfg-kpi-accent-bar"></div>
    <div class="cfg-kpi-body">
      <div class="cfg-kpi-label">{{ kpi.label || 'KPI' }}</div>
      <div class="cfg-kpi-value" :title="fullValue">{{ displayValue }}</div>
      <div v-if="kpi.description" class="cfg-kpi-sub">{{ kpi.description }}</div>
    </div>
  </div>
</template>

<script>
import { aggregate } from './utils/aggregations'
import { fmtValue } from './utils/formatting'
import { CHART_PALETTE } from './utils/theme'

export default {
  name: 'DashboardKpi',
  props: {
    kpi: { type: Object, required: true },
    data: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
    highlight: { type: Boolean, default: false },
  },
  computed: {
    rawValue() {
      return aggregate(this.data, this.kpi.field, this.kpi.agg || 'sum')
    },
    displayValue() {
      return fmtValue(this.rawValue, this.kpi)
    },
    fullValue() {
      try {
        return Number(this.rawValue).toLocaleString('en-IN')
      } catch (e) {
        return String(this.rawValue)
      }
    },
    accentColor() {
      return this.kpi.color || CHART_PALETTE[this.index % CHART_PALETTE.length]
    },
  },
}
</script>

<style scoped>
.cfg-kpi-card {
  position: relative;
  background: var(--dash-surface);
  border-radius: 12px;
  border: 1px solid var(--dash-border);
  overflow: hidden;
  transition: transform .15s ease, box-shadow .15s ease, background 0.3s ease;
  display: flex;
}
.cfg-kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px -12px var(--dash-shadow);
}
.cfg-kpi-card--sel {
  border: 2px solid var(--dash-accent) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--dash-accent) 20%, transparent) !important;
  transform: none;
}
.cfg-kpi-accent-bar {
  width: 5px;
  background: var(--kpi-accent, var(--dash-accent));
  flex-shrink: 0;
}
.cfg-kpi-body { padding: 14px 18px; flex: 1; min-width: 0; }
.cfg-kpi-label {
  font-size: .72rem; color: var(--dash-text-muted);
  text-transform: uppercase; letter-spacing: .6px; margin-bottom: 6px;
  font-weight: 600;
}
.cfg-kpi-value {
  font-size: 1.65rem; font-weight: 700; color: var(--dash-text);
  line-height: 1.1;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.cfg-kpi-sub {
  margin-top: 4px;
  font-size: .72rem; color: var(--dash-text-muted);
}
@media (max-width: 480px) {
  .cfg-kpi-value { font-size: 1.25rem; }
}
</style>
